'use client'

import React from 'react'

import Main from '../main'

const NotFoundLayout: React.FC = () => {
  return (
    <Main>
      <div className="flex items-center text-center justify-center p-20 h-80 w-full">
        <h1 className="text-7xl">Error 404</h1>
      </div>
    </Main>
  )
}

export default NotFoundLayout
